module.exports = __webpack_public_path__ + "static/media/picto-wikipedia.80df3dec.svg";